export class Company {
  constructor(_context) {
    this._context = _context;
  }
  onLoadData() {
    this._context.$store.dispatch("companies/getAll", {
      method: "GET",
      endpoint: "companies",
      item: "companies",
      query_params: {
        format: "json",
        user: localStorage.getItem("userData"),
      },
    });
  }
  setData() {
    try {
      this._context.companies = this._context.$store.state.companies.all.items;
    } catch (error) {
      console.log(`Error ${error}`);
    }
  }
}
